// import images
import cynthiaImg from './assets/img/cynthia.png';
import maximusImg from './assets/img/maximus.png';
import victorImg from './assets/img/victor.png';

export const navData = [{
        name: 'Features',
        href: 'features',
    },
    {
        name: 'Reviews',
        href: 'reviews',
    },
    {
        name: 'Crypto',
        href: 'crypto',
    },
    {
        name: 'Contact',
        href: 'contact',
    },
];

export const reviews = [{
        image: cynthiaImg,
        name: 'Cynthia Xena',
        position: 'CFO of Upload',
        description: 'Seamless and efficient payment experience, revolutionizing the way we conduct transactions. ',
    },
    {
        image: maximusImg,
        name: 'Maximus Von Alder',
        position: 'AI Researcher',
        description: 'One of the most impressive aspects of Artemis is its data-driven insights. ',
    },
    {
        image: victorImg,
        name: 'Victor Val',
        position: 'Financial Advisor',
        description: 'From a financial advisors perspective, the analytics and reporting capabilities of Artemis are truly remarkable.',
    },
];